export default __webpack_public_path__ + "de3ac17ff870e2f0d2f5584e1102a245.png";